import { render, staticRenderFns } from "./KonfirmasiWakilPialang.vue?vue&type=template&id=5e78eb8a&scoped=true&"
import script from "./KonfirmasiWakilPialang.vue?vue&type=script&lang=js&"
export * from "./KonfirmasiWakilPialang.vue?vue&type=script&lang=js&"
import style0 from "./KonfirmasiWakilPialang.vue?vue&type=style&index=0&id=5e78eb8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e78eb8a",
  null
  
)

export default component.exports